var map = {
	"./duanwu_ps_01.jpg": "65cdc",
	"./duanwu_ps_02.jpg": "1dae",
	"./duanwu_ps_03.jpg": "77c8",
	"./duanwu_ps_04.jpg": "4394",
	"./duanwu_ps_05.jpg": "5fa1",
	"./duanwu_ps_06.jpg": "0566",
	"./duanwu_ps_07.jpg": "ea47",
	"./duanwu_ps_08.jpg": "66d3",
	"./duanwu_ps_09.jpg": "291b",
	"./duanwu_ps_10.jpg": "a733",
	"./duanwu_ps_11.jpg": "85ff",
	"./duanwu_ps_12.jpg": "2d1e",
	"./duanwu_ps_13.jpg": "76e2",
	"./duanwu_ps_14.jpg": "0055",
	"./duanwu_ps_15.jpg": "792e",
	"./duanwu_ps_16.jpg": "2420",
	"./duanwu_ps_17.jpg": "9644",
	"./duanwu_ps_18.jpg": "ff7a",
	"./duanwu_ps_19.jpg": "9a7c",
	"./duanwu_ps_20.jpg": "315b",
	"./duanwu_ps_21.jpg": "2e3e",
	"./duanwu_ps_22.jpg": "726d",
	"./duanwu_ps_23.jpg": "fd16",
	"./duanwu_ps_24.jpg": "d6f6",
	"./duanwu_ps_25.jpg": "d15e",
	"./duanwu_ps_26.jpg": "1044",
	"./duanwu_ps_27.jpg": "4081",
	"./duanwu_ps_28.jpg": "3c8b",
	"./duanwu_ps_29.jpg": "fd5a",
	"./duanwu_ps_30.jpg": "ef60"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b5e1";